const SEARCH_WORDS = /"[^"]+"|[^ ]+/g;
const QUOTED_PHRASE = /^"(.*)"$/;
const LINE_BREAKS = /[\r\n\u2028]/g;
const CELL_SEPARATOR = '  ';
const MARKUP_OR_ENTITY = /[<&]/;

export function searchWordsOf(term) {
  return (term.match(SEARCH_WORDS) || [])
    .map(word => word.replace(QUOTED_PHRASE, '$1').replace('"', '').toLowerCase())
    .filter(word => word.length);
}

function withoutMarkup(text) {
  if (!MARKUP_OR_ENTITY.test(text)) return text;

  const element = document.createElement('div');
  element.innerHTML = text;

  return element.textContent;
}

function cellValueOf(column, row) {
  const value = column.data === null ? row : row[column.data];

  if (column.render) return column.render(value, 'filter', row);

  return column.data === null ? column.defaultContent : value;
}

function searchableTextOf(column, row) {
  const value = cellValueOf(column, row);
  const text = value === null || value === undefined ? '' : String(value);

  return withoutMarkup(text).replace(LINE_BREAKS, '');
}

export function searchTextOf(row, columns) {
  return columns
    .filter(column => column.searchable !== false)
    .map(column => searchableTextOf(column, row))
    .join(CELL_SEPARATOR)
    .toLowerCase();
}

export function hasEverySearchWord(searchText, words) {
  return words.every(word => searchText.includes(word));
}
